import { render, staticRenderFns } from "./PayRollPage.vue?vue&type=template&id=6fc3988d&scoped=true&"
import script from "./PayRollPage.vue?vue&type=script&lang=js&"
export * from "./PayRollPage.vue?vue&type=script&lang=js&"
import style0 from "./PayRollPage.vue?vue&type=style&index=0&id=6fc3988d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc3988d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc3988d')) {
      api.createRecord('6fc3988d', component.options)
    } else {
      api.reload('6fc3988d', component.options)
    }
    module.hot.accept("./PayRollPage.vue?vue&type=template&id=6fc3988d&scoped=true&", function () {
      api.rerender('6fc3988d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/payroll/PayRollPage.vue"
export default component.exports